export default {
  MANGOOLS_AUTH_PATH: '/users/auth',
  MANGOOLS_LOGOUT_PATH: '/logged_out'
};